export default {
    completed: {
        label: 'Completed',
        icon: 'check_circle',
        iconColor: '#5e884e',
    },
    active: {
        label: 'Active',
        icon: 'play_circle',
        iconColor: '#5a84a1',
    },
    planned: {
        label: 'Planned',
        icon: 'schedule',
        iconColor: '#8e8459',
    },
    dropped: {
        label: 'Dropped',
        icon: 'block',
        iconColor: '#885d4f',
    },
};
